module.exports = __webpack_public_path__ + "img/IyJJVHJb.9940923a.svg";